import React, { Fragment, useEffect, useState } from "react";
import AboutUsHeroSection from "./AboutUsHeroSection";
import "../../Css/AboutUs.css";
import AboutSprigstack from "./AboutSprigstack";
import WhyWeAreBest from "./WhyWeAreBest";
import CompaniesTrusted from "./CompaniesTrusted";
import Team from "./Team";
import Banner from "./Banner";
import Review from "./Review";
import KnowUs from "./KnowUs";
import DedicatedTeam from "./DedicatedTeam";
import LifeAtSS from "./LifeAtSS";

export default function AboutUsDashboard() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);
  return (
    <Fragment>
      <AboutUsHeroSection />
      <AboutSprigstack />
      <WhyWeAreBest />
      <CompaniesTrusted />
      <Team />
      <Banner />
      <Review />
      <KnowUs />
      <DedicatedTeam />
      <LifeAtSS />
    </Fragment>
  );
}
